import { Chip } from "@mui/material";

export default function StatusChip({ active, activeLabel = "Active", inactiveLabel = "Inactive" }) {
  return (
    <Chip
      size="small"
      label={active ? activeLabel : inactiveLabel}
      color={active ? "success" : "default"}
      variant={active ? "filled" : "outlined"}
    />
  );
}
